var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal",
    {
      attrs: { open: _vm.open, "event-name": "openRefresh", "hide-scroll": "" },
      on: { close: _vm.closeModal }
    },
    [
      _c("template", { slot: "header" }, [
        _c("h1", [_vm._v(_vm._s(_vm.$t("auto-logout.title")))])
      ]),
      _vm._v(" "),
      _c("template", { slot: "body" }, [
        _c("p", [
          _vm._v(
            _vm._s(
              _vm.$tc("auto-logout.expiration", _vm.expiresInMinutes, {
                time: _vm.expiresInMinutes
              })
            )
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "btns-container" },
          [
            _c(
              "x-button",
              {
                staticClass: "dark",
                attrs: { disabled: _vm.refreshing },
                on: { click: _vm.exit }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("auto-logout.logout")) +
                    "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "x-button",
              {
                staticClass: "md-raised md-primary",
                attrs: { disabled: _vm.refreshing },
                on: { click: _vm.refreshClick }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("auto-logout.login")) +
                    "\n      "
                )
              ]
            )
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }